import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { LIGHT_BLUE, PRIMARY_BLUE } from '../../Constants/Colors.constants';

const useStyles = makeStyles(() => ({
  progressBar: {
    height: '6px',
    '&[value]': {
      '-webkit-appearance': 'none',
      appearance: 'none',
      '&::-webkit-progress-bar': {
        backgroundColor: LIGHT_BLUE,
        borderRadius: '10px',
      },
      '&::-webkit-progress-value': {
        backgroundColor: PRIMARY_BLUE,
        borderRadius: '10px',
      },
    },
  },
}));

export const SimpleProgressBar = ({
  value,
  max,
  className,
}: {
  value: number;
  max: number;
  className?: string;
}) => {
  const { classes } = useStyles();
  return (
    <progress value={value} max={max} className={`${classes.progressBar} ${className || ''}`} />
  );
};
